import { useEffect, useState } from 'react';
import Link from 'next/link';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import _ from 'lodash';
import PropTypes from 'prop-types';

const BlogPagePagination = (props) => {

    const { prevPage, nextPage, count } = props;

    const { publicRuntimeConfig } = getConfig();
    
    const blogPaginationSize = publicRuntimeConfig.DEFAULT_BLOG_PAGINATION_PAGE_SIZE;
    const pageCount = Math.ceil(count / blogPaginationSize);
    const router = useRouter();
    const pageParamInt = parseInt(_.get(router, 'query.page') || 1);
    const activeNext = pageParamInt !== nextPage;

    const [numberLinks, setNumberLinks] = useState(null);

    useEffect(() => {
        setNumberLinks(calculateDefaultLinks());
    }, [prevPage, nextPage]);

    const calculateDefaultLinks = () => {
        const numbers = [];
        for (let i = 1; i <= pageCount; i += 1) {            
            const isLast = pageParamInt === pageCount;
            const marginRight = isLast ? '10px' : '0px';
            const className = i === pageParamInt
                ? 'blog-page-pagination-number-button-selected'
                : 'blog-page-pagination-number-button-not-selected';
            numbers.push(
                <div key={i}>
                    <Link href={`/blog?page=${i}#top`} className={className} style={{ marginRight }}>
                        {i}
                    </Link>
                </div>,
            );            
        }
        return numbers;
    };

    if (pageCount === 1) {
        return null;
    }    

    let active = pageParamInt !== 1;

    return (

        <div className='container-root container-root-maxWidthLg blog-page-pagination-container'>

            <div className='blog-page-pagination-link-button-container'>

                <Link href={`/blog?page=${prevPage}#top`} className={active ? 'blog-page-pagination-prev-button-active' : 'blog-page-pagination-prev-button-non'}>                    
                    Prev
                </Link>

                {numberLinks}                

                <Link href={`/blog?page=${nextPage}#top`} className={activeNext ? 'blog-page-pagination-next-button-active' : 'blog-page-pagination-next-button-non'}>                    
                    Next
                </Link>

            </div>

        </div>

    );
};

export default BlogPagePagination;

BlogPagePagination.propTypes = {
    prevPage: PropTypes.number,
    nextPage: PropTypes.number,
    count: PropTypes.number,
};
